import React from "react";
import "../autoridad.css";

const HomeAuthority = () => {
  return (
    <section className="home-authority">
      <div className="home-authority-content">

        <h3 className="authority-eyebrow">
          Equipamiento profesional
        </h3>

        <h2 className="authority-title">
          Distribuidor de marcas internacionales
          para atletas competitivos
        </h2>

        <p className="authority-text">
          Trabajamos con marcas como SBD, Inzer, Avancus y otras referencias
          del powerlifting mundial.
        </p>

        <div className="authority-badges">
          <span>✔ Productos originales</span>
          <span>✔ Envíos a todo el país</span>
          <span>✔ Encargá con el 20%</span>
          <span>✔ Atención personalizada</span>
        </div>

      </div>
    </section>
  );
};

export default HomeAuthority;
